import { render, staticRenderFns } from "./FormularioPrograma.vue?vue&type=template&id=9b1d8d12&scoped=true"
import script from "./FormularioPrograma.vue?vue&type=script&lang=js"
export * from "./FormularioPrograma.vue?vue&type=script&lang=js"
import style0 from "./FormularioPrograma.vue?vue&type=style&index=0&id=9b1d8d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1d8d12",
  null
  
)

export default component.exports